import { useEffect } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

import { useTelegramHaptics } from "../hooks/telegram";

interface TopNotificationProps {
  icon?: IconDefinition;
  message: string;
  buttonText?: string;
  gotoLink?: string;
}

export default function TopNotification({
  icon,
  message,
  buttonText,
  gotoLink,
}: TopNotificationProps) {
  const { hapticFeedback } = useTelegramHaptics();
  const handleButtonClick = () => {
    if (gotoLink) {
      window.location.href = gotoLink;
    }
  };

  useEffect(() => {
    hapticFeedback("medium");
  }, [hapticFeedback]);

  return (
    <motion.div
      className="fixed top-4 left-4 right-4 flex items-center max-w-md w-[calc(100%-2rem)] p-3 rounded-xl bg-gradient-to-r from-secondary-100 to-secondary-200 shadow-2xl shadow-dark/30 backdrop-blur-md border border-light/10 z-50"
      initial={{ x: -100, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: -100, opacity: 0 }}
      transition={{ type: "spring", stiffness: 400, damping: 30 }}
    >
      <div className="flex items-center gap-3 w-full">
        {icon && (
          <motion.div
            className="p-2 rounded-lg bg-dark/10"
            whileHover={{ scale: 1.05, rotate: 5 }}
            transition={{ type: "spring", stiffness: 400 }}
          >
            <FontAwesomeIcon icon={icon} className="text-lg text-dark" />
          </motion.div>
        )}
        <div className="flex flex-col items-start flex-1">
          <p className="text-dark/80 text-sm leading-snug">{message}</p>
        </div>
        {buttonText && (
          <motion.button
            className="px-3 py-1.5 rounded-lg text-dark text-xs font-semibold hover:bg-secondary-300 border border-dark transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={(e) => {
              e.stopPropagation();
              handleButtonClick();
            }}
          >
            {buttonText}
          </motion.button>
        )}
      </div>
    </motion.div>
  );
}
